module.exports = __webpack_public_path__ + "img/full2-min.348e2082.png";